import React from "react";

import { Button as AntButton, ButtonProps as AntButtonProps } from "antd";

import { goTo, trackMixpanel, useNavigate } from "utils";

import { Spin } from "components";

export type ButtonType = "primary" | "secondary" | "text" | "light primary" | "light secondary" | "light text" | "tertiary" | "link";

export type ButtonProps = Omit<AntButtonProps, "type"> & {
  dataTestId?: string;
  loading?: boolean;
  type?: ButtonType;
  mixpanelText?: string;
  iconLeft?: boolean;
};

enum spinSize {
  small = "small",
  middle = "default",
  large = "large",
}

export const Button = ({
  children,
  type,
  size,
  style,
  disabled,
  loading,
  onClick,
  htmlType,
  className,
  block,
  id,
  icon,
  iconLeft,
  dataTestId,
  mixpanelText,
  href, // DO NOT add href as a prop of buttons
  target,
}: ButtonProps) => {
  const navigate = useNavigate();
  const forceIconLeft = iconLeft || type === "text" || type === "light text";

  const baseType = type === "tertiary" ? "icon-tertiary" : type;
  const allClassNames = [baseType, className ?? ""].join(" ").trim();

  return (
    <AntButton
      data-testid={dataTestId}
      // @ts-expect-error We have added custom css classes matching the type
      type={type}
      size={size}
      style={style}
      disabled={disabled || loading}
      onClick={(e) => {
        trackMixpanel("ClickButton", { buttonText: mixpanelText || (typeof children === "string" && children) || "undefined" });
        if (href) {
          goTo(e, navigate, href);
        }
        onClick?.(e);
      }}
      htmlType={htmlType}
      className={allClassNames}
      block={block}
      id={id}
      target={target || "_self"}
    >
      {forceIconLeft ? icon : null}
      {loading && <Spin size={spinSize[size || "middle"]} />}
      {children}
      {forceIconLeft ? null : icon}
    </AntButton>
  );
};

export default Button;
